import {createSelector} from 'reselect';
import getValidationErrorsFromModelState from '../shared/services/getValidationErrorsFromModelState';
import {roles} from './constants';

export const getReturnPath = state => state.features.authentication.pages.verifyUser.get('returnPath');

const getCurrentUser = state => state.features.authentication.currentUser;
export const getCurrentUserEmail = createSelector(
  getCurrentUser,
  currentUser => currentUser.get('email'));
export const getCurrentUserId = createSelector(
  getCurrentUser,
  currentUser => currentUser.get('id'));
export const getCurrentUserIsAuthenticated = createSelector(
  getCurrentUser,
  currentUser => currentUser.get('authenticated'));
export const getCurrentUserRoles = createSelector(
  getCurrentUser,
  currentUser => currentUser.get('roles'));
export const getCurrentUserRole = createSelector(
  getCurrentUser,
  currentUser => currentUser.get('role'));
export const getCurrentUserIsAdmin = createSelector(
  getCurrentUserRole,
  currentUserRole => currentUserRole === roles.ADMIN || currentUserRole === roles.EDUCATION_ADMIN);
export const getCurrentUserHasProjectTeamologySchool = createSelector(
  getCurrentUser,
  currentUser => currentUser.get('hasProjectTeamologySchool'));
const getLoginPageModelState = state => state.features.authentication.pages.logIn.get('modelState');
export const getLoginPageValidationErrors = createSelector(
  getLoginPageModelState,
  modelState => getValidationErrorsFromModelState(modelState));



// WEBPACK FOOTER //
// ./app/features/authentication/selectors.js